module.exports = __webpack_public_path__ + "img/logo.38b47241.png";